import React, { useState } from "react";
import ImageUploading from "react-images-uploading";
// mui
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

import { CloudUpload, DeleteOutlined, EditOutlined } from "@mui/icons-material";

//
// const toBase64 = (file) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = (error) => reject(error);
//   });

function ImageUpload({ value, _callback, maxNumber }) {
  const [images, setImages] = useState([]);

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit

    setImages(imageList);
    _callback(imageList);
  };
  // useEffect(() => {
  //   if (defaults) {
  //     let imgs = defaults.map((v, i) => {
  //       let obj = {};
  //       fetch(v.link).then(async (response) => {
  //         const contentType = response.headers.get("content-type");
  //         const blob = await response.blob();
  //         const file = await new File([blob], v.fileName, { contentType });
  //         obj.data_url = await toBase64(file);
  //         obj.file = file;

  //         // access file here
  //       });
  //       return obj;
  //     });
  //     setImages(imgs);
  //     _callback(imgs);
  //   }
  //   console.log(images);
  // }, [defaults]);

  return (
    <ImageUploading
      multiple
      value={value}
      onChange={onChange}
      maxNumber={maxNumber}
      dataURLKey="data_url"
    >
      {({
        imageList,
        onImageUpload,
        onImageRemoveAll,
        onImageUpdate,
        onImageRemove,
        isDragging,
        dragProps,
      }) => (
        // write your building UI
        <div className="upload__image-wrapper">
          <ImageList sx={{ width: 500 }} cols={3} rowHeight={164}>
            {" "}
            {imageList.map((item, index) => (
              <ImageListItem key={item.data_url}>
                <img alt="Прикрепленное изображение" src={`${item.data_url}`} srcSet={`${item.data_url}`} />

                <ImageListItemBar
                  sx={{
                    background:
                      "linear-gradient(to bottom, rgba(0,0,0,0.9) 0%, " +
                      "rgba(0,0,0,0.5) 70%, rgba(0,0,0,0) 100%)",
                  }}
                  position="top"
                  actionIcon={
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <IconButton
                        sx={{ color: "white" }}
                        onClick={() => onImageUpdate(index)}
                      >
                        <EditOutlined />
                      </IconButton>
                      <IconButton
                        sx={{ color: "white" }}
                        onClick={() => onImageRemove(index)}
                      >
                        <DeleteOutlined />
                      </IconButton>
                    </div>
                  }
                />
              </ImageListItem>
            ))}{" "}
            {images.length < maxNumber ? (
              <ImageListItem>
                <Card
                  sx={{ height: "100%", width: "100%" }}
                  {...dragProps}
                  onClick={onImageUpload}
                >
                  <CardActionArea className="text-center h-100">
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant="h4"
                        component="div"
                        className="m-4"
                      >
                        <CloudUpload sx={{ fontSize: "2.5rem" }} />
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Добавить изображения
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </ImageListItem>
            ) : (
              ""
            )}
          </ImageList>
        </div>
      )}
    </ImageUploading>
  );
}

export default ImageUpload;
